import {
  RawGridField,
  RawReportField,
  RawUserPreferencesReport,
} from "@/entities/user-preferences-report/user-preferences-report.types";

export class UserPreferencesReport {
  version: string;
  transactionsPage: {
    gridFields: RawGridField[];
    reportFields: RawReportField[];
    pagination: { pageSize: number };
  };
  constructor(data: RawUserPreferencesReport) {
    this.version = data.version;
    this.transactionsPage = data.transactionsPage;
    if (!this.transactionsPage) {
      this.transactionsPage = {
        gridFields: [],
        reportFields: [],
        pagination: {
          pageSize: 0,
        },
      };
    }
  }
}
